/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { popupSelector } from "components/Popup/popupSlice";
import APIMoralis from "libs/apiMoralis";
import React, { Fragment, useEffect, useState } from "react";
import NftItem from "./components/NftItem";

export default function NftList() {

    const { wallet, isUpdated } = useAppSelector(popupSelector);

    const [data, setData] = useState<any[]>([]);
    const [pending, setPending] = useState(false);
    const [limit, setLimit] = useState(20);
    const [cursor, setCursor] = useState('');
    const [loadmore, setLoadmore] = useState(true);

    const api = new APIMoralis();

    const getNftList = async (address, cursor, limit) => {
        setPending(true);
        await api.getNftList(address, cursor, limit).then(
            (result) => {

                if (result.result && result.result.length > 0) {
                    const value = result.page > 0 ? [...data, ...result.result] : result.result;
                    setData(value);
                    setCursor(result.cursor);
                    if ((result.page + 1) * limit >= result.total) {
                        setLoadmore(false);
                    } else {
                        setLoadmore(true);
                    }
                } else {
                    setLoadmore(false)
                }
            },
            (error) => {
                console.log(error!.message)
            }
        )
        setPending(false);
    }

    const handleLoadmore = () => {
        if (wallet?.address) {
            getNftList(wallet.address, cursor, limit)
        }
    }

    useEffect(() => {
        if (wallet?.address) {
            getNftList(wallet.address, cursor, limit)
        }
    }, [wallet, limit])

    useEffect(() => {
        if (wallet?.address && !pending) {
            getNftList(wallet.address, '', limit)
        }
    }, [isUpdated])

    return (
        <Fragment>
            <Box
                sx={{
                    mt: 3,
                    pb: 3,
                }}
            >
                {pending &&
                    <Box sx={{ mt: 3, textAlign: 'center' }}>
                        <CircularProgress size={16} />
                    </Box>
                }
                {data.length === 0 && !pending &&
                    <Box sx={{ mt: 3, textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                        <Typography sx={{ fontSize: '13px', color: '#B1BBD2' }}>{`No NFT available`}</Typography>
                    </Box>
                }
                <Grid container spacing={2}>
                    {data && data.length > 0 && data.map((item, index) => (
                        <Grid item xs={6} key={index}>
                            <NftItem item={item} />
                        </Grid>
                    ))}
                </Grid>
                {data && data.length > 0 && loadmore &&
                    <Box
                        sx={{
                            width: '100%',
                            px: 2,
                            pt: 2,
                            pb: 2,
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <Button variant="contained"
                            sx={{
                                background: '#33394F',
                            }}
                            onClick={handleLoadmore}
                        >
                            <Typography
                                sx={{
                                    fontSize: 12,
                                }}
                            >
                                {pending ? <CircularProgress size={12} /> : 'Loadmore'}
                            </Typography>
                        </Button>
                    </Box>
                }

            </Box>
        </Fragment>
    );
}